import { NoResult } from '@devex/devex-shared';
import { HttpService } from './http-service';
import { PricingPlanEntity } from '../models/pricing-plan-entity';
import { SettingsEntity } from '../models/settings-entity';

export class SettingsService {
	public static readonly id = 'shipping-settings-service';

	public constructor(private readonly _httpService: HttpService) {}

	public async get(): Promise<SettingsEntity> {
		const settings = await this._httpService.get<SettingsEntity>('api/settings');

		return settings;
	}

	public async getInstalledShops(): Promise<{ installedShops: string[] }> {
		const installedShops = await this._httpService.get<{ installedShops: string[] }>('api/shops/installed');
		return installedShops;
	}

	public async changePlan(newPlan: string): Promise<PricingPlanEntity> {
		const response = await this._httpService.postWithResponse<PricingPlanEntity>('api/shop/pricing-plan', { newPlan: newPlan });

		return response;
	}

	public async save(settings: SettingsEntity): Promise<NoResult> {
		await this._httpService.post('/api/settings', { shippingProfiles: settings.shippingProfiles });

		await this._httpService.post('api/settings/online-mode', { onlineMode: settings.onlineMode });

		await this._httpService.post('api/settings/notifications', { notifications: settings.notifications });

		return NoResult.instance;
	}
}
